export function initDialog (btnClass) {
    const buttons = $(btnClass);
    buttons.on('click', (ev) => {
        let id = $(ev.currentTarget).attr('data-src');
        Fancybox.show([{
            src: id,
        }], {arrows: false});
    })
}

export function initVideoDialog (btnClass) {
    const buttons = $(btnClass);
    buttons.on('click', (ev) => {
        let id = $(ev.currentTarget).attr('data-src');
        Fancybox.show([{
            src: id,
            type: "iframe",
        }], {arrows: false});
    })
}

